var map = {
	"./01.svg": 46,
	"./02.svg": 47,
	"./03.svg": 48,
	"./04.svg": 49,
	"./05.svg": 50,
	"./06.svg": 51,
	"./07.svg": 52,
	"./08.svg": 53,
	"./09.svg": 54,
	"./10.svg": 55,
	"./11.svg": 56,
	"./fire.svg": 14,
	"./pepper.svg": 13
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;